module.exports = __webpack_public_path__ + "static/img/logo_白字.0c72e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_白字.png
// module id = OWCO
// module chunks = 2